/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMerchantTotalLocalCashAvailable} from '../api'

 export const useQueryGetMerchantTotalLocalCashAvailable = createReactQueryHook('getMerchantTotalLocalCashAvailable', getMerchantTotalLocalCashAvailable)
